/*
 * Copyright (c) 2021 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import Wallet from '@/services/wallet';

export default {
    namespaced: true,

    state: {
        hideZero: -1,
        gateways: {},
        addressesWithdraw: {
            coins: {},
            eth: {},
            eos: {},
            waves: {},
            bsc: {},
            ton: {},
            payeer: '',
        },
        scamAccounts: {},
        scamAssets: {},
    },

    getters: {
        hideZero: state => state.hideZero,
        gateways: state => state.gateways,
        addressesWithdraw: state => state.addressesWithdraw,
        scamAccounts: state => state.scamAccounts,
        scamAssets: state => state.scamAssets,
    },

    mutations: {
        SET_RESET (state) {
            state.gateways = {};
        },
        SET_HIDE_ZERO (state, payload) {
            state.hideZero = payload;
        },
        SET_GATEWAYS (state, payload) {
            state.gateways = payload;
        },
        SET_ADDRESS_WITHDRAW (state, payload) {
            state.addressesWithdraw[payload.network][payload.symbol] = {
                address: payload.address,
                memo: payload.memo ? payload.memo : null,
            };
        },
        SET_SCAM_ACCOUNTS (state, payload) {
            state.scamAccounts = payload;
        },
        SET_SCAM_ASSETS (state, payload) {
            state.scamAssets = payload;
        },
    },

    actions: {
        reset ({ commit }) {
            commit('SET_RESET')
        },
        async gateways ({ commit }) {
            const data = await Wallet.gateways();
            if (data) {
                commit('SET_GATEWAYS', data);
            }
            return data;
        },
        async setHideZero({ commit }, value) {
            commit('SET_HIDE_ZERO', value);
        },
        async getAddress({ commit }, values) {
            const data = await Wallet.getAddress(values);
            return data;
        },
        async checkAddress({ commit }, values) {
            const data = await Wallet.checkAddress(values);
            return data;
        },
        async saveAddress({ commit }, values) {
            commit('SET_ADDRESS_WITHDRAW', values);
        },
        async scamAccounts({ commit }) {
            const data = await Wallet.getScamAccounts();
            if (data) {
                commit('SET_SCAM_ACCOUNTS', data);
            }
            return data;
        },
        async scamAssets({ commit }) {
            const data = await Wallet.getScamAssets();
            if (data) {
                commit('SET_SCAM_ASSETS', data);
            }
            return data;
        },
    }
}
